import ReactMarkdown from 'react-markdown';

import { PageTitles } from '@revelio/core';

import { ContentWrapper } from '../../../shared/ui/content-wrapper/content-wrapper';
import DashboardPage from '../../DashboardPage';
import { TrailPageConent } from './components/trial-page-content';
import trialPageContent from './markdown/data-enrichment-content.md';

export const DataEnrichmentTrialPage = () => {
  return (
    <DashboardPage
      title={[PageTitles.DELIVERABLES, PageTitles.DATA_ENRICHMENT]}
      loading={false}
      scrollY={true}
    >
      <TrailPageConent>
        <ContentWrapper>
          <ReactMarkdown>{trialPageContent}</ReactMarkdown>
        </ContentWrapper>
      </TrailPageConent>
    </DashboardPage>
  );
};
